import * as React from 'react';
import {BasePureComponent} from './BaseComponent';
import {ChiamaAPI, Trad, Tipo, CampoNumero, CampoCheckBox} from './';
import * as Dati from '../Dati';
import * as DatiRCP from '../DatiRCP';
import * as Glob from '../Globale';

interface IGaranziaSelezionabileProps extends Dati.IBaseProps {
    Value: Glob.DatiJSON; //JSON
}

export class CampoGaranzia extends BasePureComponent<IGaranziaSelezionabileProps> {

    private _Garanzia: DatiRCP.CCampoGaranzia = new DatiRCP.CCampoGaranzia();

    public constructor(props: any) {
        super(props);

        this.OnChangeGaranzia = this.OnChangeGaranzia.bind(this);

        this.Inizializza(this.props);
    }

    private Inizializza(props: IGaranziaSelezionabileProps) {
        this.PopolaValori(props.Value);
    }

    private PopolaValori(valore: string) {
        this._Garanzia = new DatiRCP.CCampoGaranzia();
        if (valore != undefined && valore != "") {
            this._Garanzia = JSON.parse(valore);
            if (this._Garanzia.Selezionata == undefined) {
                if (this._Garanzia.ProprietaSelezione == 'S')
                    this._Garanzia.Selezionata = false;
                else if (this._Garanzia.ProprietaSelezione == 'P' || this._Garanzia.ProprietaSelezione == 'O')
                    this._Garanzia.Selezionata = true;
            } else {
                if (this._Garanzia.ProprietaSelezione == 'O')
                    this._Garanzia.Selezionata = true;
            }
            if (this._Garanzia.Icona == undefined || this._Garanzia.Icona == "") {
                this._Garanzia.Icona = "fa fa-file-signature";
            }
        } else {
            this._Garanzia = new DatiRCP.CCampoGaranzia();
        }
    }

    private OnChangeGaranzia(): void {
        if (this._Garanzia.ProprietaSelezione != 'O') {
            this._Garanzia.Selezionata = !this._Garanzia.Selezionata;
        } else {
            this._Garanzia.Selezionata = true;
        }
        this.props.OnChange(this.props.Name, JSON.stringify(this._Garanzia))
    }

    public render() {
        this.Inizializza(this.props);

        //console.warn("GARANZIA", this.props.Value);
        //console.warn("GARANZIA 2", this._Garanzia);

        return <div className={Glob.DimensioneCSS(3)}>
            <label className="kt-option garanzia">
                <span className="kt-option__control">
                    <span className="kt-checkbox kt-checkbox--brand kt-checkbox--check-bold">
                        <input type="checkbox" name={this.props.Name} id={this.props.Id}
                               checked={this._Garanzia.Selezionata}
                               onChange={this.OnChangeGaranzia}/>
                        <span>
                        </span>
                    </span>
                </span>
                <span className="kt-option__label">
                    <span className="kt-option__head">
                        <span
                            className="kt-option__title">{Trad.Trad(this._Garanzia.ID_TipoGaranzia)}</span>
                    </span>
                    <span className="kt-option__body">{this._Garanzia.Descrizione}</span>
                </span>
                <span className="kt-option__control">
                    <i className={this._Garanzia.Icona}></i>
                </span>
            </label>
        </div>;
    }
}



// WEBPACK FOOTER //
// ./src/components/CampoGaranzia.tsx